import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { CartContext } from '../context/CartContext';

const PoojaPaymentSuccess = () => {
  const location = useLocation();
  const { setCart, setSelectedAddons } = useContext(CartContext);
  const [status, setStatus] = useState('Checking');
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const orderNumber = params.get('order_number');
    const sessionId = params.get('session_id');

    if (!orderNumber || !sessionId) {
      setStatus('Error');
      return;
    }

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/orders/payment-status`, {
        params: { orderNumber, sessionId },
      })
      .then((res) => {
        setStatus(res.data.status);
        setData(res.data);
        if (res.data.status === 'Paid') {
          setCart([]);
          setSelectedAddons({});
        }
      })
      .catch((err) => {
        console.error('Unable to verify pooja payment', err);
        setStatus('Error');
      });
  }, [location.search, setCart, setSelectedAddons]);

  return (
    <div className="orders-page-wrapper">
      <div className="orders-container">
        <header className="orders-header">
          <div>
            <p className="drawer-eyebrow">Secure Checkout</p>
            <h1>{status === 'Paid' ? 'Booking Confirmed' : 'Verifying Payment'}</h1>
          </div>
        </header>

        <div className="checkout-panel">
          {status === 'Checking' && <p>Verifying your payment. This may take a moment.</p>}
          {status === 'Paid' && (
            <>
              <h3>Thank you for your booking.</h3>
              <p>Your payment has been recorded and your pooja booking is confirmed.</p>
              <p><strong>Order:</strong> {data?.orderNumber}</p>
              <p><strong>Amount:</strong> ${data?.amount}</p>
            </>
          )}
          {status === 'Pending' && (
            <p>Payment is still pending. Please check again shortly or contact support with order {data?.orderNumber}.</p>
          )}
          {status === 'Error' && (
            <p>We could not verify this payment. Please contact support if your card was charged.</p>
          )}
          <Link className="primary-btn checkout-btn" to="/uc/ViewOrders">View My Bookings</Link>
          <Link className="continue-shopping-btn link-style" to="/uc/panditpurshothit">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
};

export default PoojaPaymentSuccess;
